import Vue from "vue"
import Vuex from "vuex"
import createPersistedState from "vuex-persistedstate"

import App from "./store/modules/AppStore"
import TipoTarea from "./store/modules/tarea/TipoTareaStore"
import AdmTarea from "./store/modules/tarea/AdmTareaStore"
import UserTarea from "./store/modules/tarea/UserTareaStore"
import TipoNotificacion from "./store/modules/notificacion/TipoNotificacionStore"
import NotificationGestor from "./store/modules/notificacion/NotificacionGestorStore"
import Notification from "./store/modules/notificacion/NotificacionStore"
import UserNotificacion from "./store/modules/notificacion/UserNotificacionStore"
import Historial from "./store/modules/HistorialStore"

import User from "./store/modules/UserStore"
import Auth from "./store/modules/AuthStore"
import Role from "./store/modules/RoleStore"

import Empleado from "./store/personal/empleado/EmpleadoStore"
import Asistencia from "./store/personal/empleado-asistencia/AsistenciaStore"
import Justificacion from "./store/personal/empleado-asistencia/AsistenciaJustificacionStore"
import Nomina from "./store/personal/nomina/NominaStore"
import Estadistica from "./store/personal/empleado-estadistica/EmpleadoEstadisticaStore"

import Campus from "./store/personal/campus/CampusStore"
import Departamento from "./store/personal/departamento/DepartamentoStore"
import Seccion from "./store/personal/seccion/SeccionStore"
import Puesto from "./store/personal/puesto/PuestoStore"
import Escolaridad from "./store/personal/escolaridad/EscolaridadStore"
import EstadoCivil from "./store/personal/estado-civil/EstadoCivilStore"
import Sexo from "./store/personal/sexo/SexoStore"
import Titulo from "./store/personal/titulo/TituloStore"
import MotivoBaja from "./store/personal/motivo-baja/MotivoBajaStore"

import SolicitudPago from "./store/finanzas/solicitud-pago/SolicitudPagoStore"
import SolicitudMonto from "./store/finanzas/solicitud-pago/SolicitudMontoStore"
import Activo from "./store/finanzas/activo/ActivoStore"

import Banco from "./store/finanzas/banco/BancoStore"
import Concepto from "./store/finanzas/concepto/ConceptoStore"
import Edificio from "./store/finanzas/edificio/EdificioStore"
import Area from "./store/finanzas/area/AreaStore"
import FormaPgo from "./store/finanzas/forma-pago/FormaPagoStore"
import TipoMonto from "./store/finanzas/tipo-monto/TipoMontoStore"
import ActivoCategoria from "./store/finanzas/categoria/CategoriaStore"
import ActivoEstado from "./store/finanzas/estado/EstadoStore"
import ActivoGrupo from "./store/finanzas/grupo/GrupoStore"
import ActivoTipo from "./store/finanzas/tipo/TipoStore"
import SolicitudPagoCategoria from "./store/finanzas/solicitud-pago-categoria/SolicitudPagoCategoriaStore"

import Estudiante from "./store/cobranza/estudiante/EstudianteStore"

import Grado from "./store/cobranza/grado/GradoStore"
import Grupo from "./store/cobranza/grupo/GrupoStore"
import Curso from "./store/cobranza/curso/CursoStore"
import TipoSangre from "./store/cobranza/tipo-sangre/TipoSangreStore"
import ServicioMedico from "./store/cobranza/servicio-medico/ServicioMedicoStore"
import Ciclo from "./store/cobranza/ciclo/CicloStore"
import Tarifa from "./store/cobranza/tarifa/TarifaStore"
import TipoFinanciamiento from "./store/cobranza/tipo-financiamiento/TipoFinanciamientoStore"
import Tutor from "./store/cobranza/tutor/TutorStore"

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        App,
        TipoTarea,
        AdmTarea,
        UserTarea,
        NotificationGestor,
        TipoNotificacion,
        Notification,
        UserNotificacion,
        Historial,
        Empleado,
        User,
        Auth,
        Campus,
        Departamento,
        Seccion,
        Puesto,
        Escolaridad,
        EstadoCivil,
        Sexo,
        Titulo,
        MotivoBaja,
        Asistencia,
        Justificacion,
        Nomina,
        Grado,
        Grupo,
        Tutor,
        Ciclo,
        Tarifa,
        TipoFinanciamiento,
        Role,
        SolicitudPago,
        SolicitudMonto,
        Activo,
        Banco,
        Concepto,
        Edificio,
        Area,
        FormaPgo,
        TipoMonto,
        ActivoCategoria,
        ActivoGrupo,
        ActivoEstado,
        ActivoTipo,
        SolicitudPagoCategoria,
        Estudiante,
        TipoSangre,
        ServicioMedico,
        Curso,
        Estadistica
    },

    plugins: [
        createPersistedState({
            paths: [
                "Auth.user",
                "UserNotificacion.load_unread_notificaciones",
                "UserNotificacion.timer_unread_notificaciones"
            ]
        })
    ]
})
